var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"align-center justify-center",staticStyle:{"height":"100%"}},[_c('v-col',{staticClass:"text-center"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }